<template>
  <div class="columns is-multiline">

    <Sub title="Gruppo termico" tag="GT" v-model:elements="implant.generator_thermals" v-slot="slotProps" :codes="implant.codes" @transfer="element => $emit('transfer', element, 'generator_thermals')">
      <Thermal :element="slotProps.element" />
    </Sub>

    <Sub title="Bruciatore" tag="BR" v-model:elements="implant.generator_burners" v-slot="slotProps" title_linked="Collegato al gruppo termico" :elements_linked="implant.generator_thermals" :codes="implant.codes">
      <Burner :element="slotProps.element" />
    </Sub>

    <Sub title="Recuperatore / Condensatore" tag="RC" v-model:elements="implant.generator_recoverers" v-slot="slotProps" title_linked="Collegato al gruppo termico" :elements_linked="implant.generator_thermals" :codes="implant.codes">
      <Recoverer :element="slotProps.element" />
    </Sub>

    <Sub title="Gruppo frigo / Pompa di calore" tag="GF" v-model:elements="implant.generator_pumps" v-slot="slotProps" :codes="implant.codes">
      <Pump :element="slotProps.element" />
    </Sub>

    <Sub title="Scambiatore" tag="SC" v-model:elements="implant.generator_exchangers" v-slot="slotProps" :codes="implant.codes">
      <Exchanger :element="slotProps.element" />
    </Sub>

    <Sub title="Cogeneratore / Trigeneratore" tag="CG" v-model:elements="implant.generator_cogenerators" v-slot="slotProps" :codes="implant.codes">
      <Cogenerator :element="slotProps.element" />
    </Sub>

    <Sub title="Campo solare" tag="CS" v-model:elements="implant.generator_solars" :codes="implant.codes">
      <template #header>
        <div class="column is-12" v-if="implant.generator_solars?.length">
          <div class="columns is-multiline">
            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputText name="Superficie totale mq" v-model="implant.surface_total" />
            </div>
            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputText name="N. collettori" v-model="implant.number_collectors" />
            </div>
            <div class="column is-12-mobile is-6-tablet is-4-desktop">
              <InputSelect
                name="Utilizzo"
                v-model="implant.usage_solar"
                :options="['ACS', 'Risc']"
                multiple
              />
            </div>
          </div>
        </div>
      </template>

      <template #default="slotProps">
        <Solar :element="slotProps.element" />
      </template>
    </Sub>

    <Sub title="Altro generatore" tag="AG" v-model:elements="implant.generator_others" v-slot="slotProps" :codes="implant.codes">
      <Other :element="slotProps.element" />
    </Sub>

  </div>
</template>
  
<script>
import Thermal from './_4-generators/thermal'
import Burner from './_4-generators/burner'
import Recoverer from './_4-generators/recoverer'
import Pump from './_4-generators/pump'
import Exchanger from './_4-generators/exchanger'
import Cogenerator from './_4-generators/cogenerator'
import Solar from './_4-generators/solar'
import Other from './_4-generators/other'

export default {
  components: {
    Thermal,
    Burner,
    Recoverer,
    Pump,
    Exchanger,
    Cogenerator,
    Solar,
    Other
  },

  props: {
    implant: Object
  },
  emits: ['update:implant', 'transfer'],
}
</script>